"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-desktop
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.71
 * Contact: bithighlander@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeepKeyWalletEndpointsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class KeepKeyWalletEndpointsApi extends runtime.BaseAPI {
    /**
     */
    async binanceGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.binanceGetAddress === null || requestParameters.binanceGetAddress === undefined) {
            throw new runtime.RequiredError('binanceGetAddress', 'Required parameter requestParameters.binanceGetAddress was null or undefined when calling binanceGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/binanceGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressToJSON)(requestParameters.binanceGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async binanceGetAddress(requestParameters, initOverrides) {
        const response = await this.binanceGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async btcGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.bTCGetAddress === null || requestParameters.bTCGetAddress === undefined) {
            throw new runtime.RequiredError('bTCGetAddress', 'Required parameter requestParameters.bTCGetAddress was null or undefined when calling btcGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/btcGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BTCGetAddressToJSON)(requestParameters.bTCGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async btcGetAddress(requestParameters, initOverrides) {
        const response = await this.btcGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async cosmosGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.cosmosGetAddress === null || requestParameters.cosmosGetAddress === undefined) {
            throw new runtime.RequiredError('cosmosGetAddress', 'Required parameter requestParameters.cosmosGetAddress was null or undefined when calling cosmosGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/cosmosGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.CosmosGetAddressToJSON)(requestParameters.cosmosGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async cosmosGetAddress(requestParameters, initOverrides) {
        const response = await this.cosmosGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async eosGetPublicKeyRaw(requestParameters, initOverrides) {
        if (requestParameters.eosGetPublicKey === null || requestParameters.eosGetPublicKey === undefined) {
            throw new runtime.RequiredError('eosGetPublicKey', 'Required parameter requestParameters.eosGetPublicKey was null or undefined when calling eosGetPublicKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/eosGetPublicKey`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.EosGetPublicKeyToJSON)(requestParameters.eosGetPublicKey),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async eosGetPublicKey(requestParameters, initOverrides) {
        const response = await this.eosGetPublicKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async ethGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.eTHGetAddress === null || requestParameters.eTHGetAddress === undefined) {
            throw new runtime.RequiredError('eTHGetAddress', 'Required parameter requestParameters.eTHGetAddress was null or undefined when calling ethGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/ethGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.ETHGetAddressToJSON)(requestParameters.eTHGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async ethGetAddress(requestParameters, initOverrides) {
        const response = await this.ethGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getPublicKeysRaw(requestParameters, initOverrides) {
        if (requestParameters.getPublicKey === null || requestParameters.getPublicKey === undefined) {
            throw new runtime.RequiredError('getPublicKey', 'Required parameter requestParameters.getPublicKey was null or undefined when calling getPublicKeys.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/getPublicKeys`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getPublicKey.map(models_1.GetPublicKeyToJSON),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.GetPublicKeys200ResponseInnerFromJSON));
    }
    /**
     */
    async getPublicKeys(requestParameters, initOverrides) {
        const response = await this.getPublicKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async osmosisGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.osmosisGetAddress === null || requestParameters.osmosisGetAddress === undefined) {
            throw new runtime.RequiredError('osmosisGetAddress', 'Required parameter requestParameters.osmosisGetAddress was null or undefined when calling osmosisGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/osmosisGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.OsmosisGetAddressToJSON)(requestParameters.osmosisGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async osmosisGetAddress(requestParameters, initOverrides) {
        const response = await this.osmosisGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async rippleGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.rippleGetAddress === null || requestParameters.rippleGetAddress === undefined) {
            throw new runtime.RequiredError('rippleGetAddress', 'Required parameter requestParameters.rippleGetAddress was null or undefined when calling rippleGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/rippleGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.RippleGetAddressToJSON)(requestParameters.rippleGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async rippleGetAddress(requestParameters, initOverrides) {
        const response = await this.rippleGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async thorchainGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.thorchainGetAddress === null || requestParameters.thorchainGetAddress === undefined) {
            throw new runtime.RequiredError('thorchainGetAddress', 'Required parameter requestParameters.thorchainGetAddress was null or undefined when calling thorchainGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/thorchainGetAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.ThorchainGetAddressToJSON)(requestParameters.thorchainGetAddress),
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async thorchainGetAddress(requestParameters, initOverrides) {
        const response = await this.thorchainGetAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.KeepKeyWalletEndpointsApi = KeepKeyWalletEndpointsApi;
